import { log, LogLevel } from "logging/datadogBrowserLogs";
import z from "zod";

const replacedEventReferenceSchema = z.object({
  uuid: z.string(),
  type: z.literal("REPLACED_EVENT_REF"),
});

const replacedByEventReferenceSchema = z.object({
  uuid: z.string(),
  type: z.literal("REPLACED_BY_EVENT_REF"),
});

const incidentReferenceSchema = z.object({
  incident_id: z.string(),
  type: z.literal("INCIDENT_REF"),
});

const productionDeviationReferenceSchema = z.object({
  id: z.string(),
  type: z.literal("PRODUCTION_DEVIATION_REF"),
});

// Backend's fallback type.
const generalReferenceSchema = z.object({
  actual_type: z.string(),
  type: z.literal("GENERAL_REF"),
});

const knownReferenceSchema = z.discriminatedUnion("type", [
  replacedEventReferenceSchema,
  replacedByEventReferenceSchema,
  incidentReferenceSchema,
  productionDeviationReferenceSchema,
  generalReferenceSchema,
]);

/**
 * A fallback incase we are missing a referenceSchema. I made this since I dont want
 * this schema to be a landmine whenever reference is updated in opInfo but not here
 *
 * Type must be `any` since it is used during preprocesss
 */
const fallbackToGeneralReference = (val: any) => {
  const isValidType = knownReferenceSchema.safeParse(val).success;
  if (!isValidType) {
    const type = val?.type ?? "No types found";
    const warn = `Unknown reference type: ${type}. Falling back to general reference.`;
    log(LogLevel.warn, "referenceSchema", warn);
    return { actual_type: type, type: "GENERAL_REF" };
  }
  return val;
};

export const referenceSchema = z.preprocess(
  fallbackToGeneralReference,
  knownReferenceSchema,
);
